import React from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useIntl } from "react-intl";

const DatePickerLocalizationProvider = ({ children }) => {
    const intl = useIntl();

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={intl.locale}>
            {children}
        </LocalizationProvider>
    );
};

export default DatePickerLocalizationProvider;
